export default ({ app, $axios, redirect, $tvFetch }, inject) => {
  const api = {}

  // 获取首页banner
  api.getIndexBanner = function (data) {
    return $axios({
      url: `/cms/web/pc/homePage/banners`,
      method: 'get',
      params: data
    })
  }

  // 获取首页板块列表
  api.getIndexList = function (data) {
    return $axios({
      url: `/cms/web/pc/homePage/singleAlbums`,
      method: 'get',
      // headers: {
      //   clientType: 'ios_default',
      //   versionCode: 9
      // },
      params: data
    })
  }

  // 获取合集详情
  api.getCollectionList = (id, page = 0, size = 18) => {
    return $axios({
      url: `/cms/web/pc/album/detail`,
      method: 'get',
      params: {
        id,
        page,
        size
      }
    })
  }
  // 获取文章列表
  api.getArticleList = (page = 0, size = 9) => {
    return $axios({
      url: `/cms/web/pc/news/list`,
      method: 'get',
      params: {
        page,
        size
      }
    })
  }

  // 获取文章详情
  api.getArticle = (id) => {
    return $axios({
      url: `/cms/web/pc/news/detail`,
      method: 'get',
      params: {
        id
      }
    })
  }

  // 获取推荐文章
  api.getArticleRank = () => {
    return $axios({
      url: `/cms/web/pc/news/latestTop10`,
      method: 'get'
    })
  }

  // 获取筛选项条件内容
  api.getFilterParams = () => {
    return $axios({
      url: `/cms/web/pc/search/list`,
      method: 'get'
    })
  }

  // 获取筛选结果
  api.getSearchAndFilterResult = function (data) {
    return $axios({
      url: `/cms/web/pc/search/search`,
      method: 'post',
      data
    })
  }

  api.fetchDetail = function (params) {
    return $axios({
      url: `/cms/web/pc/movieDrama/get`,
      method: 'get',
      params
    })
  }

  // 获取预览地址
  api.fetchPlayLinkPreview = function (data) {
    return $axios({
      url: `/cms/web/pc/movieDrama/previewInfo`,
      method: 'post',
      data
    })
  }
  // 获取播放地址
  api.fetchPlayLink = function (data) {
    return $axios({
      url: `/cms/web/pc/movieDrama/getPlayInfo`,
      method: 'get',
      params: data
    })
  }
  // 获取下载页面下载链接
  api.fetchDownloadLink = function (data) {
    return $axios({
      url: `/cms/web/pc/download/urls`,
      method: 'get',
      params: data
    })
  }

  api.getServiceList = function (data, header = {}) {
    return $axios({
      url: `/api/getServiceConvergeList`,
      method: 'get',
      params: data,
      headers: header
    })
  }

  /**
   * 搜索联想
   */
  api.searchLenovo = function (data) {
    return $axios({
      url: `/cms/web/pc/search/searchLenovo`,
      method: 'post',
      data
    })
  }
  /**
   * 搜索排行
   */
  api.fetchSearchTop = function (params) {
    return $axios({
      url: `/cms/web/pc/search/searchLeaderboard`,
      method: 'get',
      params
    })
  }
  /**
   * 搜索电视或电视剧
   */
  api.searchWithKeyWord = function (data) {
    return $axios({
      url: `/cms/web/pc/search/searchWithKeyWord`,
      method: 'post',
      data
    })
  }
  /**
   * 获取用户登录信息
   */
  api.getUserInfo = function (token) {
    return $axios({
      url: `/user/web/login/info`,
      method: 'get',
      headers: {
        token
      }
    })
  }

  /**
   * 获取二维码链接和信息
   */
  api.loadQrcode = function () {
    return $axios({
      url: `/user/qrcode/info`,
      method: 'get'
    })
  }
  /**
   * 获取二维码扫描状态
   */
  api.getScanState = function (params) {
    return $axios({
      url: `/user/qrcode/state`,
      method: 'get',
      params
    })
  }
  /**
   * 退出登录
   */
  api.logout = function (params) {
    return $axios({
      url: `/user/web/login/logout`,
      method: 'get',
      params
    })
  }
  /**
   * 退出登录
   */
  api.queryPlaceHolder = function (params) {
    return $axios({
      url: `/cms/web/pc/search/placeHolder`,
      method: 'get',
      params
    })
  }
  /**
   * 获取配置地址
   */
  api.querySnsByArea = function (params) {
    return $axios({
      url: `/config/web/website/sns/getSnsByArea`,
      method: 'get',
      params
    })
  }
  /**
   * 获取关键词配置
   */
  api.queryKeyword = function (params) {
    return $axios({
      url: '/config/web/website/keyword/byLanguage',
      method: 'get'
    })
  }
  /**
   * 获取sitemap
   */
  api.querySitemap = function () {
    return $axios({
      url: '/sitemap/sitemap_all.xml',
      method: 'get'
    })
  }

  api.pcFeedback = function (data) {
    return $axios({
      url: `/user/behavior/h5/pc/feedback/add`,
      method: 'post',
      data
    })
  }

  api.qiniuToken = function (params) {
    return $axios({
      url: `/third/qiniu/app/h5/token`,
      method: 'get',
      params
    })
  }

  api.questionList = function () {
    return $axios({
      url: '/cms/pc/question/list',
      method: 'get'
    })
  }

  api.tvVipGoods = function (params, headers = {}) {
    return $tvFetch({
      url: '/commodity/h5/market/vip/goods/list',
      method: 'get',
      options: {
        headers
      }
    })
  }

  api.tvUserInfo = function (params, headers = {}) {
    return $tvFetch({
      url: '/user/vip/h5/all',
      method: 'get',
      options: {
        headers
      }
    })
  }

  api.tvArticleDetail = function (params, headers = {}) {
    return $tvFetch({
      url: `/cms/app/article/detail`,
      method: 'get',
      options: {
        headers,
        params
      }
    })
  }

  api.tvQrCodeUrlKey = function (body, headers = {}) {
    return $tvFetch({
      url: `/commodity/h5/market/vip/goods/qrCodeUrlKey`,
      method: 'post',
      options: {
        body,
        headers
      }
    })
  }

  //参考 https://www.nuxtjs.cn/guide/plugins
  inject('api', api)
}
